import { secrets } from "./secrets/secrets.staging";
import { ABTestConfig } from "src/app/models/ab-tests";

export const environment = {
  production: false,
  version: "1.3.10",
  host: "https://web-staging.bitoasisdev.com",

  api: {
    url: "https://api-staging.bitoasisdev.com" /* 'https://api-k8s.bitoasisdev.net', */,
    websocket: "wss://wss-staging.bitoasisdev.com",
    clientId: "bitoasis-webapp",
    clientSecret:
      secrets.api.clientSecret /* '7kNQtZsoZkaf8GnQZfMMhnJZ4DpzDm9y' */,
    type: "web",
  },
  tap: {
    public_key: secrets.tap.public_key,
  },
  googleAnalytics: {
    id: "G-49YVYC8YZ5",
  },
  segmentAnalytics: {
    key: secrets.segmentAnalytics.key,
  },
  amplitudeAnalytics: {
    key: secrets.amplitudeAnalytics.key,
  },
  kekaCareers: {
    key: secrets.kekaCareers.key,
  },
  clevertapTracking: {
    accountId: "WW8-674-446Z",
  },
  sentry: {
    enabled: false,
    env: "staging",
    dns: secrets.sentry.dns,
  },
  currencies: {
    globalCurrency: "USD",
    defaultCurrency: "AED",
    gccCurrencies: ["BHD", "QAR", "KWD", "OMR", "SAR"],
    fiatCurrencies: ["AED", "USD", "SAR", "BHD", "QAR", "KWD", "OMR"],
    stableCurrencies: ["USDT", "USDC"],
    disabledWithdrawCurrencies: ["USD"],
  },
  countries: {
    KWT: {
      currency: "KWD",
      fiatWithdrawFee: "6 KWD",
      ccFees: "5%",
    },
    BHR: {
      currency: "BHD",
      fiatWithdrawFee: "7 BHD",
      ccFees: "5%",
    },
    QAT: {
      currency: "QAR",
      fiatWithdrawFee: "65 QAR",
      ccFees: "5%",
    },
    OMN: {
      currency: "OMR",
      fiatWithdrawFee: "7 OMR",
      ccFees: "5%",
    },
    ARE: {
      currency: "AED",
      fiatWithdrawFee: "65 AED",
      ccFees: "3.675%",
    },
    SAU: {
      currency: "SAR",
      fiatWithdrawFee: "65 SAR",
      ccFees: "3.675%",
    },
  },
  hcaptcha: {
    enabled: true,
    siteKey: secrets.hcaptcha.siteKey,
    passiveSiteKey: secrets.hcaptcha.passiveSiteKey,
  },
  blog: {
    api: "https://blog.bitoasis.net/wp-json/wp/v2",
    homePage: {
      postsNumber: 5,
      category: {
        en: 315,
        ar: 323,
      },
    },
    announcements: {
      category: {
        en: 291,
        ar: 293,
      },
      duration: 12000,
      utm: "utm_source=website&utm_medium=website-announcements-area&utm_campaign=website-announcements&utm_content=textlink",
    },
    howProWorks: {
      slug: "how-pro-works",
    },
  },
  links: {
    apiDocs: "https://api.bitoasis.net/doc/",
    whatsappSupport: "https://wa.me/962797222083",
    vipSupportEmail: "vip@bitoasis.net",
    blog: "https://blog.bitoasis.net/",
    careers: "https://careers.smartrecruiters.com/Bitoasis",
    support: {
      en: "https://support.bitoasis.net/en/support/home",
      ar: "https://support.bitoasis.net/ar/support/home",
    },
    liquidityDisclaimer: {
      en: "https://support.bitoasis.net/en/support/solutions/articles/29000042697-order-routing-order-book",
      ar: "https://support.bitoasis.net/ar/support/solutions/articles/29000042697-order-routing-order-book",
    },
    bugBounty: "https://yeswehack.com/programs/bitoasis-bug-bounty-program",
  },
  firebase: {
    apiKey: secrets.firbase.apiKey,
    authDomain: "bitoasis-android.firebaseapp.com",
    databaseURL: "https://bitoasis-android.firebaseio.com",
    projectId: "bitoasis-android",
    storageBucket: "bitoasis-android.appspot.com",
    messagingSenderId: "851288762731",
    appId: "1:851288762731:web:d6c25b5e156489edbf042e",
    measurementId: "G-K2D7M7FLB2",
    vapidKey: secrets.firbase.vapidKey,
  },
  aBTests: {
    T00001: {
      // mubashirPlaceOrderText
      versions: ["C", "T1"],
      weights: { C: 50, T1: 50 },
    },
  } as Record<string, ABTestConfig>,
  p2p: {
    enabled: false,
  },
  instantBuy: {
    bannerEnabled: true,
  },
};
